import { SYSTEM_STATUS } from "./options/SYSTEM_STATUS";
import { PARSE_STATUS } from "./options/PARSE_STATUS";
import { SUB_STATUS } from "./options/SUB_STATUS";
import { FILE_STATUS } from "./options/FILE_STATUS";

export function getPayedInvoiceStatusColorv2(points) {
  let color = "default";

  if (points >= 0 && points < 1000) {
    if (points < 100) {
      // orange om mindre än 100
      color = "warning";
    } else if (points === 100) {
      color = "primary";
    } else {
      color = "success";
    }
  }

  return color;
}

export function getPayedInvoiceStatusColor(points) {
  let color = "default";

  if (points >= 0 && points < 1000) {
    if (points < 20) {
      // röd om mindre än 20
      color = "error";
    } else if (points >= 20 && points < 100) {
      color = "warning";
    } //orange 20-99
    else {
      color = "success";
    }
  }

  return color;
}

export const getSystemStatusColorById = (systemStatusID) => {
  const systemStatusObj = SYSTEM_STATUS.find((el) => el.id === systemStatusID);

  if (systemStatusObj) {
    return systemStatusObj.color;
  } else {
    return "primary";
  }
};

export const getSystemStatusColorByLabel = (systemStatusLabel) => {
  const systemStatusObj = SYSTEM_STATUS.find(
    (el) => el.label === systemStatusLabel
  );

  if (systemStatusObj) {
    return systemStatusObj.color;
  } else {
    return "primary";
  }
};

export const getFileStatusColorByLabel = (label) => {
  const fileStatus = FILE_STATUS.find((el) => el.label === label);

  if (fileStatus) {
    return fileStatus.color;
  } else {
    return "primary";
  }
};

export const getSubStatusColorById = (subStatusID) => {
  const subStatusObj = SUB_STATUS.find((el) => el.id === subStatusID);

  if (subStatusObj) {
    return subStatusObj.color;
  } else {
    return "primary";
  }
};

export const getParseStatusColorById = (parseStatusId) => {
  const parseStatusObj = PARSE_STATUS.find((el) => el.id === parseStatusId);

  if (parseStatusObj) {
    return parseStatusObj.color;
  } else {
    return "primary";
  }
};

export const getParseStatusColorByLabel = (
  parseStatusLabel,
  ignoreWarnings = 0
) => {
  const parseStatusObj = PARSE_STATUS.find(
    (el) => el.label === parseStatusLabel
  );

  if (ignoreWarnings && parseStatusObj.id === 2) {
    return "default";
  }

  if (parseStatusObj) {
    return parseStatusObj.color;
  } else {
    return "primary";
  }
};
